function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useEffect } from 'react';
// log rocket needs to extend event handlers and does so in strict mode
// that means if they're not extendable (ebmla carousels) then it'll throw
// and exceptions are bad!
export default function useFixLogRocket() {
    useEffect(function() {
        var oldAddListener = HTMLDivElement.prototype.addEventListener;
        HTMLDivElement.prototype.addEventListener = function addEventListener(name, fn) {
            for(var _len = arguments.length, options = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                options[_key - 2] = arguments[_key];
            }
            if (Object.isExtensible(fn)) {
                return oldAddListener.apply(this, [
                    name,
                    fn
                ].concat(_to_consumable_array(options)));
            }
            function wrappedFn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _fn;
                return (_fn = fn).call.apply(_fn, [
                    this
                ].concat(_to_consumable_array(args)));
            }
            Object.keys(fn).forEach(function(key) {
                wrappedFn[key] = fn[key];
            });
            return oldAddListener.apply(this, [
                name,
                wrappedFn
            ].concat(_to_consumable_array(options)));
        };
        return function() {
            HTMLDivElement.prototype.addEventListener = oldAddListener;
        };
    }, []);
}
